import { useEffect } from 'react';

import { useListController } from '@ocx-app/hooks/useListController';

import { usePaymentInstruments, PaymentInstrument } from '@ocx/data-payment-instruments';

export const usePaymentInstrumentsController = () => {
  const {
    defaultPaymentInstrumentId,
    refetch: refetchPaymentInstruments,
    loading: isPaymentInstrumentsLoading,
    paymentInstruments,
    isWalletSizeLimitReached,
    walletSizeLimit,
    isWalletEnabled,
  } = usePaymentInstruments({
    canBeUsedToPayEquals: true,
  });

  const paymentInstrumentsListSelector = useListController<PaymentInstrument>({
    listItems: paymentInstruments.map((instrument) => ({ ...instrument, id: instrument.uuid })),
  });

  // Hook watching "defaultPaymentInstrumentId" updates
  // and "selecting" default payment instrument
  useEffect(() => {
    if (!defaultPaymentInstrumentId) {
      return;
    }
    if (paymentInstrumentsListSelector.selectedListItem?.uuid === defaultPaymentInstrumentId) {
      return;
    }
    const defaultPaymentInstrument = paymentInstruments.find(({ uuid }) => uuid === defaultPaymentInstrumentId);
    if (!defaultPaymentInstrument) {
      return;
    }
    paymentInstrumentsListSelector.handleSelect({ ...defaultPaymentInstrument, id: defaultPaymentInstrument.uuid });

    // Use single dependency of defaultId allows handle and update selected payment instrument correctly
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultPaymentInstrumentId]);

  return {
    paymentInstruments,
    paymentInstrumentsListSelector,
    isPaymentInstrumentsLoading,
    refetchPaymentInstruments,
    isCardsAvailable: isWalletEnabled,
    isWalletSizeLimitReached,
    walletSizeLimit,
    isWalletEnabled,
  };
};
